// store.ts
import { create } from "zustand";

export const useStore = create((set) => ({
    settings : {tg: "https://t.me/School_Tenishevoi_Bot",
        vk: "https://vk.com/tenisheva_school",
        phone: "+74812229555",
        email: "oktsmolensk@gmail.com",
        address: "Смоленск, Ново-Ленинградская улица, 8",
        pay4base: 286500,
        pay4middle: 274000,
        studyyears: '2025-2026'},
}));
